import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=bcdf719e&scoped=true"
import script from "./DeleteButton.vue?vue&type=script&lang=ts"
export * from "./DeleteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcdf719e",
  null
  
)

export default component.exports